import { Option } from '@sapphire/result';

import { Nullable } from '@ps/utils';

/** A cached value paired with the timestamp it was cached at, keyed together so the two can never drift out of sync. */
export interface CachedEntry<T> {
  data: T;
  cachedAt: Nullable<number>;
}

export const mostRecentCacheKey = (
  cachedAt: Record<string, Nullable<number>>,
): Nullable<string> => {
  const cachedEntries = Object.entries(cachedAt).filter(
    (entry): entry is [string, number] => !!entry[1],
  );

  return Option.from(cachedEntries.length ? cachedEntries : null).mapOr(
    null,
    (entries) =>
      entries.reduce((latest, entry) =>
        entry[1] > latest[1] ? entry : latest,
      )[0],
  );
};
